import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export default function PageTransition({ children }) {
  const { pathname } = useLocation()
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    el.style.opacity = '0'
    const raf = requestAnimationFrame(() => {
      if (ref.current) {
        ref.current.style.opacity = '1'
      }
    })
    return () => cancelAnimationFrame(raf)
  }, [pathname])

  return (
    <div
      ref={ref}
      style={{
        transition: 'opacity 180ms ease-out',
      }}
    >
      {children}
    </div>
  )
}
